import React, { useEffect, useState } from "react";
import { BiSolidSun, BiSolidMoon } from "react-icons/bi";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { FaCaretDown } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import { FaMoneyBillWave } from "react-icons/fa";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";
import { Link } from "react-router-dom";
import { FaWallet } from "react-icons/fa";

const Navbar2 = () => {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light",
  );
  const [showMenu, setShowMenu] = useState(false);
  const [balance, setBalance] = useState(0);
  const element = document.documentElement;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    if (theme === "dark") {
      element.classList.add("dark");
      localStorage.setItem("theme", "dark");
      // console.log("dark theme");
    } else {
      element.classList.remove("dark");
      localStorage.setItem("theme", "light");
      //  console.log("light theme");
    }
  }, [theme]);
  const handleLogout = (e) => {
    e.preventDefault(); // prevent default link navigation
    localStorage.removeItem("userInfo"); // remove user info if stored
    window.location.href = "/login"; // redirect to login page
  };
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  //  console.log("user detail : ", userInfo);
  return (
    <>
      <header
        data-aos="fade"
        data-aos-duration="300"
        className="relative z-[99] border-b-[1px]  border-primary/50 bg-gradient-to-l from-violet-950 via-violet-800 to-violet-950 text-white shadow-lg"
      >
        <nav className="container  flex h-[70px] items-center justify-between py-2 ">
          <div className="text-2xl text-white md:text-3xl font-serif">
            <a href="/betamountpage" className="">
              እናት
              <span className="inline-block font-bold text-primary font-serif">
                ቢንጎ
              </span>
            </a>
          </div>
          {/* Desktop Menu */}
          <div className="hidden md:block">
            <ul className="flex items-center gap-10 font-serif">
              <li className="cursor pointer">
                <a href="/">Home</a>
              </li>
              <li className="cursor pointer">
                <a href="/HowToPlay">How To Play</a>
              </li>
              <li className="cursor pointer">
                <a href="/referralIncome">Referral Income</a>
              </li>
              <li className="cursor pointer">
                <a href="https://t.me/ethbingos">Contact Us</a>
              </li>
              {/* Phone number section */}
              <div className="flex items-center gap-4">
                <li>
                  <FaMoneyBillWave className="h-[40px] w-[40px] rounded-md bg-primary p-2 text-2xl text-white hover:bg-primary/90" />
                </li>
                <li>
                  <div>
                    <p className="text-sm">ETB</p>
                    <p className="text-lg">
                      {" "}
                      <a href="/wallet">{balance}</a>
                    </p>
                  </div>
                </li>
              </div>
              {/* Light and dark mode switcher */}
              {theme === "dark" ? (
                <BiSolidSun
                  onClick={() => setTheme("light")}
                  className="text-2xl"
                />
              ) : (
                <BiSolidMoon
                  onClick={() => setTheme("dark")}
                  className="text-2xl"
                />
              )}
              <li className="group relative cursor-pointer">
                <a href="/" className="flex h-[72px] items-center gap-[2px]">
                  {userInfo?.username}
                  <span>
                    <FaCaretDown className="transition-all duration-200 group-hover:rotate-180" />
                  </span>
                </a>
                <div className="absolute -left-9 z-[9999] hidden w-[150px] rounded-md bg-white p-2 text-black group-hover:block  ">
                  <ul className="space-y-3">
                    <li>
                      <a
                        href="/wallet"
                        className="p-2 hover:bg-violet-200 block"
                      >
                        Wallet
                      </a>
                    </li>
                    <li>
                      <a
                        href="/profile"
                        className="p-2 hover:bg-violet-200 block"
                      >
                        Profile
                      </a>
                    </li>
                    <li>
                      <a
                        href="/history"
                        className="p-2 hover:bg-violet-200 block"
                      >
                        History
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={handleLogout}
                        className="p-2 hover:bg-violet-200 block"
                      >
                        Log out
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>

          {/* Mobile view  */}
          <div className="flex items-center gap-4 md:hidden ">
            <Link
              to="/wallet"
              className="
        inline-flex items-center gap-2
        px-4 py-2
        rounded-full
        border border-primary/50
        bg-gradient-to-l from-violet-950 via-violet-800 to-violet-950
        text-white font-semibold text-sm
        shadow-lg
        hover:shadow-xl hover:scale-105
        transition-all duration-200
        active:scale-95
      "
            >
              <FaWallet className="text-green-200 text-sm" />
              <span className="text-sm">ETB {balance}</span>
            </Link>
            {showMenu ? (
              <HiMenuAlt1
                onClick={toggleMenu}
                className=" cursor-pointer transition-all"
                size={30}
              />
            ) : (
              <HiMenuAlt3
                onClick={toggleMenu}
                className="cursor-pointer transition-all"
                size={30}
              />
            )}
          </div>
        </nav>
      </header>
      <ResponsiveMenu showMenu={showMenu} />
    </>
  );
};

export default Navbar2;
